import { socketUpdateView } from "@/socket";

export const shouldLastPlayStatusChange = (isPresent, ply) => {
  if (isPresent.lastplaystatus === undefined) return 0;
  if (
    Math.floor(ply.currentTime()) - isPresent.lastplaystatus > 5 ||
    Math.floor(ply.currentTime()) - isPresent.lastplaystatus < -5
  )
    return Math.floor(ply.currentTime());
  else return isPresent.lastplaystatus;
};

export const viewsCount = async ({
  meta,
  cid,
  vid,
  uid,
  socket,
  isviewsCount,
}) => {
  //views count
  if (!meta.views) {
    let willcount = await isviewsCount(
      `${cid}_${vid._id}`,
      vid?.duration,
      meta
    );
    if (willcount) {
      socketUpdateView(
        {
          vid: vid._id,
          uid: uid,
        },
        socket
      );
    }
  }
};
